export enum ClientAuthActions {
    FetchClientAuthCerts = 'FETCH_CLIENT_AUTH_CERTS',
    GenerateCertToken = 'GENERATE_CLIENT_AUTH_CERT',
    EnableClientAuthCert = 'ENABLE_CLIENT_AUTH_CERT'
}